import { useParams, Navigate } from "react-router-dom";
import ServiceSeoGeo from "@/pages/ServiceSeoGeo";
import ServiceWebsiteDev from "@/pages/ServiceWebsiteDev";
import StubPage from "@/pages/StubPage";

const MAP = {
  "seo-geo": ServiceSeoGeo,
  "website-development": ServiceWebsiteDev,
};

export default function ServiceRouter() {
  const { slug } = useParams();
  const Component = MAP[slug];
  if (!slug) return <Navigate to="/services" replace />;
  if (Component) return <Component />;
  return (
    <StubPage
      testId="service-coming-soon"
      eyebrow="Service"
      title="Detailed page coming soon."
      description="We're polishing this service page. In the meantime, explore our other services or book a free audit."
    />
  );
}
